import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=ef87adf2&"
import script from "./Tutorial.vue?vue&type=script&lang=ts&"
export * from "./Tutorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports